import { Fragment } from "react";
import { Outlet, useLocation } from "react-router-dom";

import MainAppBar from "src/layouts/appbar";
import usePlayer from "src/hooks/usePlayer";
import { PATH_DASHBOARD } from "src/routes/paths";
import DockedMiniPlayer from "src/pages/components/watch/MiniPlayer";
import MainFooter from "./Footer";

export default function MainPageLayout() {
  const location = useLocation();
  const { minimized, videoData } = usePlayer();

  return (
    <Fragment>
      {!location.pathname.includes(PATH_DASHBOARD.watch) && (
        <MainAppBar
          mode={
            location.pathname.includes(PATH_DASHBOARD.account)
              ? "light"
              : "dark"
          }
        />
      )}
      <Outlet />
      {videoData && minimized && <DockedMiniPlayer />}
      {location.pathname.includes(PATH_DASHBOARD.account) && <MainFooter />}
    </Fragment>
  );
}
